import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

import type { SlideViewMode } from "../slide/slide";

@customElement("bp-main-point-slide")
export class MainPointSlide extends LitElement {
  static styles = css`
    .main-point-slide {
      background-color: var(--slide-accent-color);
      width: 100%;
      height: 100%;
      display: block;
    }

    .content {
      color: var(--color-white);
      font-size: var(--font-size-5xl);
      line-height: var(--line-height-snug);
      min-height: var(--slide-default-height);
      margin: 0 var(--size-7);
      display: grid;
      place-items: center;
    }
  `;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    return html`
      <div class="main-point-slide ${this.viewMode}">
        <div class="content">
          <slot></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-main-point-slide": MainPointSlide;
  }
}
